import snowRoutes from '@/modules/snow/router/'
import irrigationRoutes from '@/modules/irrigation/router/'
import lawnRoutes from '@/modules/lawn/router/'

var emptyRoutes = []
var routes = emptyRoutes.concat(
  snowRoutes,
  irrigationRoutes,
  lawnRoutes
)

export default routes
